<template>
  <Teleport to="#dialog">
    <transition appear name="fade">
      <div class="dialog">
        <div
          :class="['dialog-box', `${style?.cusClass || ''}`]"
          :style="`
            width:${style?.width || '100%'};
            height:${style?.height || '99vh'};
            grid-template-rows:${style?.dialogRows}; 
            min-height:${style?.minHeight || ''}`"
        >
          <div v-if="!hideClose" class="dialog-cancel" @click="close">
            <i class="bi bi-x-circle-fill"></i>
          </div>
          <slot name="title">
            <p v-if="title" class="dialog-title">{{ title }}</p>
          </slot>
          <slot name="body"></slot>
          <slot name="footer"></slot>
        </div>
      </div>
    </transition>
  </Teleport>
</template>
<script>
import { inject } from 'vue';
export default {
  name: 'cus-order-dialog',
  setup() {
    const title = inject('order_title', '');
    const close = inject('order_close');
    const hideClose = inject('order_hideClose', false);
    const { style } = inject('order_style');
    return { title, close, hideClose, style };
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  @include dialog-basic;
}
</style>
